import { forwardRef, useImperativeHandle, useRef } from 'react';
import { cx } from '@chakra-ui/utils';
import { useTranslation } from 'react-i18next';

import { InputControlProps } from '../../../@types';

import { InputControl } from './InputControl';

export const ExpiryControl = forwardRef((props: InputControlProps, ref) => {
  const { t } = useTranslation();
  const inputRef = useRef();

  useImperativeHandle(ref, () => ({
    beforeSubmit() {},
    async validate() {
      await (inputRef.current as any)?.validate();
    },
  }));

  return (
    <InputControl
      ref={inputRef}
      className={cx('card-form-expiry-input')}
      {...props}
      rules={{
        validate: {
          valid: (val: any) => {
            if (val.trim() === '') return true;
            const year = new Date().getFullYear() % 100;
            const month = new Date().getMonth() + 1;
            const values = val?.split('/') || [];
            if (+values[1] > year && +values[0] <= 12) return true;
            if (+values[1] === year && +values[0] <= 12 && +values[0] >= month)
              return true;
            return t('invalidDate');
          },
        },
      }}
      placeholder="MM/YY"
      mask="00/00"
    />
  );
});
